import React, { forwardRef, useContext } from 'react';

import { useIntl } from 'localization';
import Question from 'tracking-fe/src/Components/TrackingPage/Modules/Questions/Question';

import { CustomerSupportedLanguage2Letter } from '../types/CustomerGeneral';
import OVCStoreDataContext from './OVCStoreDataContext';

const OVCLandingQnA = forwardRef<HTMLDivElement>((_, ref) => {
  const intl = useIntl();
  const { storeData } = useContext(OVCStoreDataContext);
  const lang = intl.locale.substring(0, 2) as CustomerSupportedLanguage2Letter;

  const questionsData = storeData.portalV2?.regionalSettings?.find(
    (x: any) => x?.language?.ISOCode === lang || x?.language?.ISOCode === intl.locale,
  )?.questions;

  return (
    <div
      className="w-full max-w-[980px] mx-auto pl-6 md:pr-6 pr-10"
      ref={ref}
      data-cy="ovc-qna-container"
      style={{ paddingTop: '50px', paddingBottom: '50px' }}
    >
      <div className="m-0 grid gap-6">
        {questionsData?.questions?.map((question: any) => (
          <Question question={question} key={question.order} />
        ))}
      </div>
    </div>
  );
});

export default OVCLandingQnA;
